class FarloUiTicketCalendar {
	constructor(element, _config) {
	  this.container = element;
	  this.options = _config;
	  this.minDate = new Date(this.container.dataset.startMonth);
	  this.maxDate = new Date(this.container.dataset.endMonth);
	  this.today = new Date();
	  this.currentDate = new Date();
  
	  this.render = this.render.bind(this);
	  this.renderHeader = this.renderHeader.bind(this);
	  this.renderDaysOfTheWeeks = this.renderDaysOfTheWeeks.bind(this);
	  this.fetchEventsForMonth = this.fetchEventsForMonth.bind(this);
  
	  this.render();
	}
  
	async render() {
	  const daysContainer = this.container.querySelector('.site-farlo-ui-ticket-calendar__days');
	  if (daysContainer) daysContainer.innerHTML = '';
  
	  this.renderHeader();
	  this.renderDaysOfTheWeeks();
  
	  await this.fetchEventsForMonth(
		this.currentDate.getFullYear(),
		this.currentDate.getMonth() + 1
	  );
	}
  
	async checkForEventsInMonth(year, month) {
	  const response = await this.fetchEventsForMonth(year, month);
	  return (
		response &&
		response.data &&
		response.data.calendarCells &&
		response.data.calendarCells.length > 0
	  );
	}
  
	async loadFirstFutureMonthWithEvents() {
	  let nextMonth = new Date(this.currentDate);
	  while (nextMonth <= this.maxDate) {
		const hasEvents = await this.checkForEventsInMonth(
		  nextMonth.getFullYear(),
		  nextMonth.getMonth() + 1
		);
		if (hasEvents) {
		  this.currentDate = nextMonth;
		  break;
		}
		nextMonth.setMonth(nextMonth.getMonth() + 1);
	  }
	}
  
	async fetchEventsForMonth(y, m) {
	  let data;
	  if (farloAjaxVendorHandler.apiKey) {
		data = new URLSearchParams({
		  action: 'getEventsFromApi',
		  nonce: farloAjaxVendorHandler.nonce,
		  month: m,
		  year: y
		});
	  } else {
		data = new URLSearchParams({
		  action: 'getEventsForMonth',
		  nonce: farloAjaxVendorHandler.nonce,
		  month: m,
		  year: y
		});
	  }
  
	  this.container.classList.add('site-farlo-ui-ticket-calendar--loading');
  
	  try {
		const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
		  method: 'POST',
		  body: data,
		  headers: {
			'Accept': 'application/json',
			'Content-type': 'application/x-www-form-urlencoded',
			'X-WP-Nonce': farloAjaxVendorHandler.nonce
		  }
		});
  
		if (!response.ok) {
		  console.error('Response status not OK:', response.status);
		  return;
		}
  
		const responseData = await response.json();
		this.container.classList.remove('site-farlo-ui-ticket-calendar--loading');
  
		// wipe and re-render header + weekdays
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
  
		const cells = responseData.data.calendarCells;
		if (cells) {
		  const temp = document.createElement('div');
		  temp.innerHTML = cells;
		  const today = new Date();
		  today.setHours(0,0,0,0);
  
		  temp.querySelectorAll('.site-farlo-ui-ticket-calendar__days-day').forEach(dayEl => {
			const rel = dayEl.getAttribute('rel');
			if (!rel) return;
			const [yy, mm, dd] = rel.split('-');
			const cellDate = new Date(yy, mm - 1, dd);
			cellDate.setHours(0,0,0,0);
			if (cellDate < today) {
			  dayEl.querySelectorAll('a.site-farlo-ui-ticket-calendar__days-link').forEach(a => {
				a.removeAttribute('href');
				a.style.pointerEvents = 'none';
				a.classList.add('sold-out');
			  });
			}
		  });
  
		  this.container.insertAdjacentHTML('beforeend', temp.innerHTML);
		}
  
		return responseData;
	  } catch (err) {
		console.error('There was an error fetching events!', err);
	  }
	}
  
	renderHeader() {
	  const header = document.createElement('div');
	  header.classList.add('site-farlo-ui-ticket-calendar__header');
  
	  // Prev button
	  const prevBtn = document.createElement('button');
	  prevBtn.classList.add(
		'site-farlo-ui-ticket-calendar__button',
		'site-farlo-ui-ticket-calendar__button--prev'
	  );
	  prevBtn.innerHTML = `<span><svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.69825 1L1 6.69825L6.69825 12.3965M1.79142 6.69825L13.3462 6.69825" stroke="#1e3527" stroke-width="1.89942" stroke-linecap="round" stroke-linejoin="round"/>
	  </svg></span>`;
  
	  // Can we go back one month-year?
	  const curY = this.currentDate.getFullYear();
	  const curM = this.currentDate.getMonth();
	  const minY = this.minDate.getFullYear();
	  const minM = this.minDate.getMonth();
	  const canGoBack = (curY > minY) || (curY === minY && curM > minM);
  
	  if (canGoBack) {
		prevBtn.addEventListener('click', () => this.prevMonth());
	  } else {
		prevBtn.classList.add('site-farlo-ui-ticket-calendar__button-disabled');
	  }
  
	  header.appendChild(prevBtn);
  
	  // Title
	  const title = document.createElement('h2');
	  title.classList.add('site-farlo-ui-ticket-calendar__header-month-year');
	  title.textContent = this.currentDate.toLocaleDateString(undefined, {
		year: 'numeric',
		month: 'long'
	  });
	  header.appendChild(title);
  
	  // Next button
	  const nextBtn = document.createElement('button');
	  nextBtn.classList.add(
		'site-farlo-ui-ticket-calendar__button',
		'site-farlo-ui-ticket-calendar__button--next'
	  );
	  nextBtn.innerHTML = `<span><svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.30175 12.6934L14 6.99511L8.30175 1.29685M13.2086 6.99511L1.65379 6.99511" stroke="#1e3527" stroke-width="1.89942" stroke-linecap="round" stroke-linejoin="round"/>
	  </svg></span>`;
  
	  const maxY = this.maxDate.getFullYear();
	  const maxM = this.maxDate.getMonth();
	  const canAdvance = (curY < maxY) || (curY === maxY && curM < maxM);
  
	  if (canAdvance) {
		nextBtn.addEventListener('click', () => this.nextMonth());
	  } else {
		nextBtn.classList.add('site-farlo-ui-ticket-calendar__button-disabled');
	  }
  
	  header.appendChild(nextBtn);
  
	  this.container.appendChild(header);
	}
  
	renderDaysOfTheWeeks() {
	  const weeks = document.createElement('div');
	  weeks.classList.add('site-farlo-ui-ticket-calendar__weeks');
	  const labels = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
	  labels.forEach(l => {
		const d = document.createElement('div');
		d.classList.add('site-farlo-ui-ticket-calendar__week-day');
		d.textContent = l;
		weeks.appendChild(d);
	  });
	  this.container.appendChild(weeks);
  
	  const daysWrapper = document.createElement('div');
	  daysWrapper.classList.add('site-farlo-ui-ticket-calendar__days');
	  this.container.appendChild(daysWrapper);
	}
  
	prevMonth() {
	  const prev = new Date(this.currentDate);
	  prev.setDate(1);
	  prev.setMonth(prev.getMonth() - 1);
  
	  // allow going back if month-year >= min month-year
	  const py = prev.getFullYear();
	  const pm = prev.getMonth();
	  const my = this.minDate.getFullYear();
	  const mm = this.minDate.getMonth();
	  if (py > my || (py === my && pm >= mm)) {
		this.currentDate = prev;
		this.render();
	  }
	}
  
	nextMonth() {
	  const next = new Date(this.currentDate);
	  next.setDate(1);
	  next.setMonth(next.getMonth() + 1);
  
	  // enforce max month-year
	  const ny = next.getFullYear();
	  const nm = next.getMonth();
	  const my = this.maxDate.getFullYear();
	  const mm = this.maxDate.getMonth();
	  if (ny < my || (ny === my && nm <= mm)) {
		this.currentDate = next;
		this.render();
	  }
	}
  
	handleEventClick(event) {
	  if (this.options.eventClick) {
		this.options.eventClick(event);
	  }
	}
  }
  
  HTMLDivElement.prototype.farloUiTicketCalendar = function(settings) {
	return new FarloUiTicketCalendar(this, settings);
  };
  